<div class="custom-table overflow-x-auto">
	<table class="mat-elevation-z8 bg-transparent w-full relative">
		<thead class="bg-light">
			<tr class="border-b-[1px] border-secondry-color-Gray">
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'REFUND.REFUNDS_LIST.REQUEST_NUM' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'REFUND.REFUNDS_LIST.BOOKING_NUM' | translate }}
				</td>
				<td
					*ngIf="refundsFilter.refundStatus == 1"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'REFUND.REFUNDS_LIST.CLIENT_NAME' | translate }}
				</td>

				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'REFUND.REFUNDS_LIST.SALON_NAME' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'REFUND.REFUNDS_LIST.REQUEST_DATE' | translate }}
				</td>
				<td
					*ngIf="
						refundsFilter.refundStatus == 3 || refundsFilter.refundStatus == 2
					"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{
						(refundsFilter.refundStatus == 2
							? 'REFUND.REFUNDS_LIST.REFUNDING_DATE'
							: 'REFUND.REFUNDS_LIST.REJECTED_DATE'
						) | translate
					}}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{
						(refundsFilter.refundStatus == 1
							? 'REFUND.REFUNDS_LIST.AMOUNT'
							: 'REFUND.REFUNDS_LIST.AMOUNT_REFUNDED'
						) | translate
					}}
				</td>
				<td
					*ngIf="refundsFilter.refundStatus == 1"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'REFUND.REFUNDS_LIST.STATUS' | translate }}
				</td>
				<td
					*ngIf="
						refundsFilter.refundStatus == 3 || refundsFilter.refundStatus == 2
					"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{
						(refundsFilter.refundStatus == 3
							? 'REFUND.REFUNDS_LIST.REJECTION_REASON'
							: 'REFUND.REFUNDS_LIST.REFUND_REASON'
						) | translate
					}}
				</td>
				<td></td>
			</tr>
		</thead>
		<tbody class="bg-grey-background">
			<tr
				*ngFor="
					let refund of refunds
						| paginate
							: {
									itemsPerPage: refundsFilter?.paging?.pageSize,
									currentPage: refundsFilter?.paging?.pageNumber,
									totalItems: totalCount
							  };
					let indx = index
				"
				class="{{
					indx + 1 != refunds?.length
						? 'border-b-[1px] border-secondry-color-Gray'
						: ''
				}}"
			>
				<td
					class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap font-Poppins-regular ltr:pl-[35px] rtl:pr-[22px]"
				>
					#{{ refund?.id }}
				</td>
				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					#{{ refund?.appointmentSerialNumber }}
					<p
						*ngIf="refundsFilter.refundStatus !== 1"
						class="m-0 text-font-14 text-medium-gray"
					>
						{{ refund?.client?.name }}
					</p>
				</td>
				<td
					*ngIf="refundsFilter.refundStatus == 1"
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ refund?.client?.name }}
				</td>

				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<p class="m-0">
						{{ refund?.serviceProviderName }}
					</p>
					<p class="m-0 text-font-14 text-medium-gray">
						{{ refund?.branchName }}
					</p>
				</td>
				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<p class="m-0">
						{{ refund?.requestDate | date : 'dd/MM/yyyy' }}
					</p>
					<p class="text-sm m-0">
						{{ refund?.requestDate | date : 'hh:mm a' : 'UTC' }}
					</p>
				</td>
				<td
					*ngIf="refundsFilter.refundStatus != 1"
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<p class="m-0">
						{{ refund?.actionDate | date : 'dd/MM/yyyy' }}
					</p>
					<p class="text-sm m-0">
						{{ refund?.actionDate | date : 'hh:mm a' : 'UTC' }}
					</p>
				</td>
				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ refund?.requestAmount }}
					<span
						*ngIf="
							refundsFilter.refundStatus == 3 || refundsFilter.refundStatus == 2
						"
						class="block text-font-14 text-medium-gray"
						>{{ refund?.actionBy }}</span
					>
				</td>

				<td
					*ngIf="refundsFilter.refundStatus == 1"
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<app-status
						[enumData]="appointmentStatus"
						[statusValue]="refund?.appointmentStatus"
					>
					</app-status>
				</td>

				<td
					*ngIf="
						refundsFilter.refundStatus == 3 || refundsFilter.refundStatus == 2
					"
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<p class="m-0">{{ refund?.refundReason }}</p>
				</td>

				<td
					class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<span
						(click)="takeAction(refund.id)"
						class="inline-block max-mobile:w-[20px] w-[16px] text-end"
					>
						<img
							[src]="'assets/images/view.svg'"
							alt=""
							class="inline-block cursor-pointer"
						/>
					</span>
				</td>
			</tr>
		</tbody>
	</table>
</div>
